import PropTypes from 'prop-types'
import { NumberField } from '../styles'

function NumberInput({ value, onChange }) {
  return (
    <NumberField
      type="number"
      className="mt-2"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}

NumberInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
}

export default NumberInput
